/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from "react";
import { useData } from "../components/context/data/DataState";
import { useParams } from "react-router-dom";
import { useAuth } from "../components/context/auth/AuthState";
import LeaderBoardBlock from "../components/Leaderboard/LeaderBoardBlock";
import ScoreBoardBlock from "../components/Leaderboard/ScoreBoardBlock";
import ScoreBoardActivityBlock from "../components/Leaderboard/ScoreBoardActivityBlock";
import api from "../services/api";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../components/ui/select";
import { Label } from "../components/ui/label";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../components/ui/dialog";

const Score = () => {
  const { data, communityId, seasonId, challengeId } = useData();
  const { currentUser } = useAuth();
  const { community_id } = useParams();
  const [season_id, setseason_id] = useState("");
  const [challenge_id, setChallenge_id] = useState("");
  const [activity_id, setActivity_id] = useState("");
  const [activity_data, setactivity_data] = useState([]);
  const [backDropInfo, setBackDropInfo] = useState({
    open: false,
    data: "",
  });
  const [userList, setuserList] = useState([]);
  const [currentUserId, setcurrentUserId] = useState(currentUser.user_id);
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (communityId === community_id) {
      setseason_id(seasonId);
      setChallenge_id(challengeId);
      handleChange(undefined, challengeId);
    }
  }, []);

  useEffect(() => {
    if (
      (data.community[community_id]?.role === "Creator" ||
        data.community[community_id]?.role === "Admin") &&
      !userList.length
    ) {
      updateUserList();
    }
  }, [data.community[community_id]?.role]);

  const updateUserList = async () => {
    api.post("/community/readUserCommunity", {
      community_id: community_id,
    })
      .then((res) => res.data)
      .then((data) => {
        if (Array.isArray(data)) setuserList(data);
      });
  };

  const verifyActivity = async (activity_id, date, verify_state) => {
    api.post("/activity/verify", {
      user_id: currentUserId,
      activity_id,
      date,
      verify_state,
    }).then((res) => {
      if (res.status === 200) {
        handleChange();
      }
    });
  };

  const handleChange = async (
    seasonId = season_id,
    challengeId = challenge_id,
    activityId = activity_id,
    current_user_id = currentUserId
  ) => {
    if (!seasonId && !challengeId && !activityId) return;
    api.post("/score/read", {
      season_id: seasonId,
      challenge_id: challengeId,
      activity_id: activityId,
      user_id: current_user_id,
    })
      .then((res) => res.data)
      .then((data) => {
        if (Array.isArray(data)) setTableData(data);
      });

    if (challengeId) {
      api.post("/activity/list", {
        challenge_id: challengeId,
        user_id: current_user_id,
      })
        .then((res) => res.data)
        .then((data) => {
          if (Array.isArray(data)) {
            const groupedData = data.reduce((acc, curr) => {
              const existing = acc.find((a) => a.activity_id === curr.activity_id);
              if (existing) {
                existing.dates.push({
                  date: curr.date,
                  quantity: curr.quantity,
                  activity_completed: curr.activity_completed,
                  image: curr.image_file_name,
                  verified: curr.verified,
                });
              } else {
                acc.push({
                  activity_id: curr.activity_id,
                  activity_name: curr.activity_name,
                  dates: [
                    {
                      date: curr.date,
                      quantity: curr.quantity,
                      activity_completed: curr.activity_completed,
                      image: curr.image_file_name,
                      verified: curr.verified,
                    },
                  ],
                });
              }
              return acc;
            }, []);
            setactivity_data(groupedData);
          }
        });
    }
  };

  if (!community_id) {
    return <div className="flex items-center justify-center h-64">Loading...</div>;
  }

  return (
    <div className="p-4 space-y-6">
      <Dialog open={backDropInfo.open} onOpenChange={(open) => setBackDropInfo({ ...backDropInfo, open })}>
        <DialogContent className="max-w-4xl">
          <DialogHeader>
            <DialogTitle>Activity Image</DialogTitle>
          </DialogHeader>
          {backDropInfo.data ? (
            <img
              src={backDropInfo.data}
              alt="Activity"
              className="w-full h-auto max-h-[80vh] object-contain"
            />
          ) : (
            <div className="text-center py-8 text-gray-500">No Image Uploaded</div>
          )}
        </DialogContent>
      </Dialog>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <Label htmlFor="season">Season</Label>
          <Select
            value={season_id}
            onValueChange={(value) => {
              setseason_id(value);
              handleChange(value);
            }}
          >
            <SelectTrigger id="season">
              <SelectValue placeholder="Select season" />
            </SelectTrigger>
            <SelectContent>
              {Object.values(data.community[community_id]?.season || {}).length === 0 && (
                <SelectItem value="none">None</SelectItem>
              )}
              {data.community[community_id]?.season &&
                Object.values(data.community[community_id]?.season || {}).map((item) => (
                  <SelectItem value={item.season_id} key={item.season_id}>
                    {item.season_name}
                  </SelectItem>
                ))}
            </SelectContent>
          </Select>
        </div>

        {season_id && (
          <div>
            <Label htmlFor="challenge">Challenge</Label>
            <Select
              value={challenge_id}
              onValueChange={(value) => {
                setChallenge_id(value);
                handleChange(undefined, value, "");
                setActivity_id("");
              }}
            >
              <SelectTrigger id="challenge">
                <SelectValue placeholder="Select challenge" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All Challenges</SelectItem>
                {data.community[community_id]?.season &&
                  Object.values(data.community[community_id]?.season[season_id].challenge || {}).map((item) => (
                    <SelectItem value={item.challenge_id} key={item.challenge_id}>
                      {item.challenge_name}
                    </SelectItem>
                  ))}
              </SelectContent>
            </Select>
          </div>
        )}

        {(data.community[community_id]?.role === "Creator" ||
          data.community[community_id]?.role === "Admin") && (
            <div>
              <Label htmlFor="user">User</Label>
              <Select
                value={currentUserId}
                onValueChange={(value) => {
                  setcurrentUserId(value);
                  handleChange(undefined, undefined, undefined, value);
                }}
              >
                <SelectTrigger id="user">
                  <SelectValue placeholder="Select user" />
                </SelectTrigger>
                <SelectContent>
                  {userList.map((item) => (
                    <SelectItem value={item.user_id} key={item.user_id}>
                      {item.first_name} {item.last_name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          )}
      </div>

      {challenge_id && (
        <div>
          <Label htmlFor="activity">Activity</Label>
          <Select
            value={activity_id}
            onValueChange={(value) => {
              setActivity_id(value);
              handleChange(undefined, undefined, value);
            }}
          >
            <SelectTrigger id="activity">
              <SelectValue placeholder="All Activities" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Activities</SelectItem>
              {activity_data.map((item, index) => (
                <SelectItem value={item.activity_id} key={index}>
                  {item.activity_name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}

      <div className="space-y-4">
        {!activity_id ? (
          tableData.map((item, index) => (
            <ScoreBoardBlock
              item={item}
              key={index}
              community_id={community_id}
              season_id={season_id}
              challenge_id={challenge_id}
              activity_id={activity_id}
            />
          ))
        ) : (
          <ScoreBoardActivityBlock
            activity_data={activity_data}
            activity_id={activity_id}
            setBackDropInfo={setBackDropInfo}
            verifyActivity={verifyActivity}
            isAdmin={
              data.community[community_id]?.role === "Creator" ||
              data.community[community_id]?.role === "Admin"
            }
          />
        )}

        {!season_id && (
          <div className="text-center text-gray-500 py-8">
            Choose a Season to Continue
          </div>
        )}
      </div>
    </div>
  );
};

export default Score;
